if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.activeIndex = 0;
        this.content = this.querySelector('.product-media-modal__content');
        this.pager = this.querySelector('[data-media-pager]');
        this.status = this.querySelector('[data-media-pager-status]');
        this.bindPager();
        this.bindKeyboard();
        this.bindSwipe();
      }

      /* Direct children only. The CSS contract in section-main-product.css
         hides every direct child of __content that lacks .active, so .active
         has to sit on the child itself, not on the img inside it.
         Children with no resolvable media id are skipped: Dawn's
         VariantSelects.updateMedia() reparents an <img> out of its skeleton
         wrapper on variant change, leaving a wrapper that holds only the
         shimmer div and would otherwise count as an empty slide. */
      get mediaItems() {
        if (!this.content) return [];
        return Array.from(this.content.children).filter((item) => this.mediaIdOf(item) !== null);
      }

      mediaIdOf(item) {
        if (item.hasAttribute('data-media-id')) return item.getAttribute('data-media-id');
        const inner = item.querySelector('[data-media-id]');
        return inner ? inner.getAttribute('data-media-id') : null;
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openerId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const index = this.mediaItems.findIndex((item) => this.mediaIdOf(item) === openerId);
        this.setActive(index === -1 ? 0 : index, false);
      }

      setActive(index, announce = true) {
        const items = this.mediaItems;
        if (!items.length) return;
        const count = items.length;
        this.activeIndex = ((index % count) + count) % count;

        window.pauseAllMedia();
        items.forEach((item, i) => item.classList.toggle('active', i === this.activeIndex));

        if (this.pager) this.pager.hidden = count < 2;
        if (announce) this.announce(this.activeIndex + 1);
        this.loadActiveDeferredMedia(items[this.activeIndex]);
      }

      loadActiveDeferredMedia(activeItem) {
        if (!activeItem) return;
        const deferred = activeItem.matches('deferred-media')
          ? activeItem
          : activeItem.querySelector('deferred-media');
        if (!deferred || typeof deferred.loadContent !== 'function') return;
        const template = deferred.querySelector('template');
        if (template && template.content.querySelector('.js-youtube')) deferred.loadContent();
      }

      step(delta) {
        this.setActive(this.activeIndex + delta);
      }

      announce(oneBasedIndex) {
        if (!this.status) return;
        const template = this.status.getAttribute('data-announce-template');
        if (!template) return;
        this.status.textContent = template.replace('[index]', oneBasedIndex);
      }

      bindPager() {
        if (!this.pager) return;

        /* global.js closes any .media-modal on mouse pointerup unless the
           target sits inside deferred-media or product-model. That handler is
           bound to the modal element, so stopping the event here keeps pager
           clicks from closing the lightbox. */
        this.pager.addEventListener('pointerup', (event) => event.stopPropagation());

        this.pager.addEventListener('click', (event) => {
          const button = event.target.closest('[data-media-pager-dir]');
          if (!button) return;
          event.preventDefault();
          this.step(button.getAttribute('data-media-pager-dir') === 'prev' ? -1 : 1);
        });
      }

      bindKeyboard() {
        this.addEventListener('keydown', (event) => {
          if (event.code !== 'ArrowLeft' && event.code !== 'ArrowRight') return;
          event.preventDefault();
          this.step(event.code === 'ArrowLeft' ? -1 : 1);
        });
      }

      bindSwipe() {
        if (!this.content) return;
        let startX = null;
        let startY = 0;

        this.content.addEventListener(
          'touchstart',
          (event) => {
            /* A pinch fires touchstart once per finger. Abandon swipe tracking
               for multi-touch: otherwise the second finger overwrites the start
               point, and whichever finger lifts first computes its delta against
               the other finger's origin, which can step the gallery mid-pinch. */
            if (event.touches.length > 1) {
              startX = null;
              return;
            }
            startX = event.changedTouches[0].clientX;
            startY = event.changedTouches[0].clientY;
          },
          { passive: true }
        );

        this.content.addEventListener(
          'touchend',
          (event) => {
            if (startX === null) return;
            const deltaX = event.changedTouches[0].clientX - startX;
            const deltaY = event.changedTouches[0].clientY - startY;
            startX = null;
            if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
            this.step(deltaX < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }
    }
  );
}
